import dayjs from 'dayjs'

export interface IDateFilter {
  startTime?: number
  endTime?: number
  label: string
}

export const OVERALL_FILTER = {
  label: 'Overall',
  startTime: 0,
  endTime: dayjs().endOf('day').unix()
}

export enum DATE_FILTER_TYPE {
  CUSTOM_DATE = 'CUSTOM_DATE',
  TODAY = 'TODAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_15_DAYS = 'LAST_15_DAYS',
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  LAST_3_MONTHS = 'LAST_3_MONTHS',
  LAST_6_MONTHS = 'LAST_6_MONTHS',
  OVERALL = 'OVERALL'
}

export const DATE_FILTER_TYPE_VS_LABEL = {
  CUSTOM_DATE: 'Custom Date',
  TODAY: 'Today',
  LAST_7_DAYS: 'Last 7 Days',
  LAST_15_DAYS: 'Last 15 Days',
  THIS_MONTH: 'This Month',
  LAST_MONTH: 'Last Month',
  LAST_3_MONTHS: 'Last 3 Months',
  LAST_6_MONTHS: 'Last 6 Months',
  OVERALL: 'Overall'
}

export const getDateFilterDetails = (dateFilterType: DATE_FILTER_TYPE) => {
  switch (dateFilterType) {
    case DATE_FILTER_TYPE.TODAY:
      return {
        startTime: dayjs().startOf('day').unix(),
        endTime: dayjs().unix()
      }
    case DATE_FILTER_TYPE.LAST_7_DAYS:
      return {
        startTime: dayjs().subtract(7, 'day').startOf('day').unix(),
        endTime: dayjs().unix()
      }
    case DATE_FILTER_TYPE.LAST_15_DAYS:
      return {
        startTime: dayjs().subtract(15, 'day').startOf('day').unix(),
        endTime: dayjs().unix()
      }
    case DATE_FILTER_TYPE.THIS_MONTH:
      return {
        startTime: dayjs().startOf('month').unix(),
        endTime: dayjs().unix()
      }
    case DATE_FILTER_TYPE.LAST_MONTH:
      return {
        startTime: dayjs().subtract(1, 'month').startOf('month').unix(),
        endTime: dayjs().subtract(1, 'month').endOf('month').unix()
      }
    case DATE_FILTER_TYPE.LAST_3_MONTHS:
      return {
        startTime: dayjs().subtract(3, 'month').startOf('month').unix(),
        endTime: dayjs().unix()
      }
    case DATE_FILTER_TYPE.LAST_6_MONTHS:
      return {
        label: 'Last 6 Months',
        startTime: dayjs().subtract(6, 'month').startOf('month').unix(),
        endTime: dayjs().unix()
      }
    case DATE_FILTER_TYPE.OVERALL:
      return {
        startTime: 0,
        endTime: dayjs().endOf('day').unix()
      }
    default:
      return {
        startTime: 0,
        endTime: dayjs().endOf('day').unix()
      }
  }
}
